import * as React from 'react';

import { MediaContext, type MediaContextData } from './media-context';

// Thin selector over MediaContext — no listeners or cookie logic. The single resize listener and
// single device-cookie writer live in MediaProvider (see media-context.tsx).
function useMedia(): MediaContextData {
  const context = React.useContext(MediaContext);
  if (!context) {
    throw new Error('useMedia can only be used inside of MediaProvider');
  }

  return context;
}

export default useMedia;
